import { useMemo } from 'react';
import { formatDate } from '../ActivityDetails.meta';
import { GroupedTransactionsDTO } from '../../../../../../../api/useGroupedTransactionsQuery';

const FILTERABLE_FIELDS = ['date', 'name', 'accountNumber', 'total', 'ticker', 'notes'];
const FILTERABLE_DETAIL_FIELDS = ['description', 'units', 'price'];

interface Params {
  data: GroupedTransactionsDTO | null | undefined;
  filter: string;
}

export const useFilteredData = ({ data, filter }: Params) => {
  return useMemo(() => {
    if (!data) {
      return null;
    }

    if (!filter) {
      return data;
    }

    const filterableFields = data.showTransactionDetail
      ? [...FILTERABLE_FIELDS, ...FILTERABLE_DETAIL_FIELDS]
      : FILTERABLE_FIELDS;

    return {
      ...data,
      groupedTransactions: data.groupedTransactions.map(group => ({
        ...group,
        transactions: group.transactions.filter(transaction => {
          return filterableFields.some(field => {
            const value = transaction[field];

            if (!value) {
              return false;
            }

            let stringValue: string;

            if (field === 'date') {
              stringValue = formatDate(transaction.date);
            } else {
              stringValue = typeof value === 'number' ? value.toString() : value;
            }

            return stringValue.toLowerCase().includes(filter.toLowerCase());
          });
        }),
      })),
    };
  }, [data, filter]);
};
